import { render, staticRenderFns } from "./details.vue?vue&type=template&id=0b8c7e9e&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=0b8c7e9e&scoped=true&lang=less&"
import style1 from "./details.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8c7e9e",
  null
  
)

export default component.exports